class DecisionTree {
  constructor(form) {
    this.check = form.classList.contains( 'configurator' ) && typeof gform !== 'undefined';
  }

  autoStep() {
    if (!this.check) {
      return;
    }
    const self = this;
    const hideNextButtons = document.querySelectorAll( '.configurator [type="button"].gform_next_button' );
    hideNextButtons.forEach( (button) => {
      button.style.visibility = 'hidden';
      button.style.height = '0';
    } )

    gform.addAction( 'gform_input_change', function (elem, formId) {
      if (!window.gf_form_conditional_logic || !self.check) {
        return;
      }

      if (!elem.closest( '.gfield' ).nextElementSibling) {
        const nextBtn = elem.closest( '.gform_page' ).querySelector( '[type="button"].gform_next_button' );
        nextBtn.click();
        nextBtn.setAttribute( 'disabled', 'disabled' );

        setTimeout( () => {
          nextBtn.removeAttribute( 'disabled' );
        }, 250 );
      }
    }, 10 );
  }
}

window.addEventListener( 'DOMContentLoaded', (event) => {
  [...document.querySelectorAll( '.gform_wrapper form' )].forEach( (form) => {
    const decisionTree = new DecisionTree( form );
    decisionTree.autoStep();
  } );
} );